import React, { useState, useEffect } from 'react';

const Typewriter = ({ text, delay = 0, style }) => {
  const [displayText, setDisplayText] = useState('');
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (index < text.length) {
        setDisplayText((prevText) => prevText + text[index]);
        setIndex((prevIndex) => prevIndex + 1);
      }
    }, index === 0 ? delay : 60);

    return () => clearTimeout(timer);
  }, [index, text, delay]);

  return <span style={style}>{displayText}</span>;
};

export default Typewriter;